import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
export function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="flex flex-col rounded-2xl bg-white p-5 shadow-lg shadow-black/20" data-id="element-20" data-mp="2o64z023bcjug">
      <span className="self-start rounded bg-brand px-2 py-0.5 font-display text-[10px] font-black uppercase tracking-wider text-white" data-id="element-21" data-mp="2t3wut772wq3x">
        Bonus {bonus.number}
      </span>
      <h3 className="mt-3 font-display text-sm font-black uppercase leading-tight text-navy md:text-base" data-id="element-22" data-mp="20fr9ai87ax31">
        {bonus.name}
      </h3>
      <p className="mt-1.5 text-xs leading-snug text-steel md:text-sm" data-id="element-23" data-mp="25b6kt3iqkgwa">{bonus.description}</p>
      <ul className="mt-3 flex-1 space-y-1.5 border-t border-navy/10 pt-3" data-id="element-24" data-mp="29db9dnubunc2">
        {bonus.includes.map(item => <li key={item} className="flex items-start gap-2 text-xs font-semibold text-navy" data-id="element-25" data-mp="1ho8362ivr2ws">
            <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-26" data-mp="1lpjucchejw73" />
            {item}
          </li>)}
      </ul>
      <div className="mt-4 flex items-center justify-between gap-3 border-t border-navy/10 pt-3" data-id="element-27" data-mp="1x0tlfvy1be11">
        <span className="text-sm font-black text-steel line-through decoration-red-600 decoration-2" data-id="element-28" data-mp="1s4cu6svjgjjq">
          ${bonus.value} USD
        </span>
        <span className="rounded-md bg-navy px-3 py-1 font-display text-xs font-black uppercase text-brand-light" data-id="element-29" data-mp="1id8f7t5v4yow">
          Free
        </span>
      </div>
    </article>;
}